import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { ExperiencesPage } from './pages/ExperiencesPage';
import { ExperienceDetailPage } from './pages/ExperienceDetailPage';
import { AboutPage } from './pages/AboutPage';
import { BookingReturnPage } from './pages/BookingReturnPage';
import { BookingFailedPage } from './pages/BookingFailedPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { experiences } from './data/experiences';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/experiences" element={<ExperiencesPage />} />
        <Route path="/about" element={<AboutPage />} />
        {/* Viva Smart Checkout redirect targets — configured on the payment
            source in the Viva banking app, not per request. */}
        <Route path="/booking/return" element={<BookingReturnPage />} />
        <Route path="/booking/failed" element={<BookingFailedPage />} />
        {experiences.map((exp) => (
          <Route
            key={exp.id}
            path={`/${exp.slug}`}
            element={<ExperienceDetailPage slug={exp.slug} />}
          />
        ))}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default App;
